function setMaxHeight() {
    const opinionsCards = [...document.querySelectorAll('.opinions-card')];

    if (opinionsCards.length) {
        const height = opinionsCards.reduce((agg, curr) => {
            const currHeight = curr.querySelector('.opinions-card-top').offsetHeight;
            return currHeight > agg ?
                currHeight :
                agg;
        }, 0) + 150;
        for (const card of opinionsCards) {
            card.style.height = `${height}px`;
        }
    }
}

window.addEventListener('DOMContentLoaded', setMaxHeight);
window.addEventListener('resize', setMaxHeight);